__webpack_require__.p = "/quiz-gatsby-assets/hair/women/quiz/";